import React, { useEffect, useMemo } from "react"
import store from "src/store"
import ExpectedEventsDeclare from "./expected-events-declare"
import { Select } from "./select"
import { useStepIndex } from "./step-index-context"

export default function ExpectedEvent() {
  var stepIndex = useStepIndex()
  store.useRerenderIfChange(() => [
    store.steps[stepIndex]?.["expected_events"],
    store.steps[stepIndex]?.["has_expected_events"],
    store.steps[stepIndex]?.["pass_if_other_event_emitted"],
  ]);

  var abis = useMemo(() => {
    var x = [];
    for (let step of store.steps) {
      if (step.abi) {
        x = [...step.abi, ...x];
      }
    }
  
    x = require("lodash").uniqBy(
      x,
      "signature"
    );

    return x;
  }, [JSON.stringify(store.steps)]);
  

  var events = useMemo(() => {
    var e = abis.filter((item) => item.type == "event")
    return e
  }, [abis])

  const onSelectEventName = (index, signature) => {
    store.removeResults(stepIndex)
    if (signature) {
      store.steps[stepIndex]["expected_events"][index]["signature"] = signature
      store.updateStore()
    } else {
      removeExpectedEvent(index)
    }
  }

  const addMoreExpectedEvent = () => {
    store.removeResults(stepIndex)
    store.steps[stepIndex]["expected_events"].push({
      name: "",
      signature: "",
      expectedEventParameters: [],
    })
    store.steps[stepIndex]["has_expected_events"] = true
    store.updateStore()
  }

  const removeExpectedEvent = (index) => {
    store.removeResults(stepIndex)
    store.steps[stepIndex]["expected_events"].splice(index, 1)
    if (!store.steps[stepIndex]["expected_events"].length) {
      store.steps[stepIndex]["has_expected_events"] = false
      store.steps[stepIndex]["pass_if_other_event_emitted"] = false
    }
    store.updateStore()
  }

  const updatedExpectedOutput = () => {
    store.removeResults(stepIndex)
    if (
      !store.steps[stepIndex]["has_expected_events"] &&
      !store.steps[stepIndex]["expected_events"].length
    ) {
      store.steps[stepIndex]["expected_events"].push({
        name: "",
        signature: "",
        expectedEventParameters: [],
      })
    } else {
      store.steps[stepIndex]["pass_if_other_event_emitted"] = false
    }
    store.steps[stepIndex]["has_expected_events"] =
      !store.steps[stepIndex]["has_expected_events"]
    store.updateStore()
  }

  const updatedPassIfOtherEventsEmitted = () => {
    store.steps[stepIndex]["pass_if_other_event_emitted"] =
      !store.steps[stepIndex]["pass_if_other_event_emitted"]
    store.updateStore()
  }

  return (
    <div css="background: white;padding-left:10px;padding-top:10px;font-size:13px;">
      <div
        css={`
          display: flex;
        `}
      >
        <div
          css={`
            width: 110px;
            flex-shrink: 0;
          `}
        >
          Expected Events
        </div>
        <div>
          <span css="font-weight: 700">
            {store.steps[stepIndex]["has_expected_events"]
              ? "There are events available"
              : "There is no events available"}
            &nbsp;
          </span>
          {!store.isStepReadOnly(stepIndex) && (
            <span
              css={`
                color: #799fd4;
                cursor: pointer;
                text-decoration-line: underline;
                justify-self: right;
                font-size: 13px;
                font-weight: 100;
              `}
              onClick={() => {
                updatedExpectedOutput()
              }}
            >
              Change
            </span>
          )}
        </div>
      </div>
      <div>
        {store.steps[stepIndex]["has_expected_events"] ? (
          <>
            {store.steps[stepIndex]["expected_events"] &&
            store.steps[stepIndex]["expected_events"].length ? (
              <div>
                {store.steps[stepIndex]["expected_events"].map(
                  (event, index) => (
                    <div css="padding-left: 110px">
                      <Select
                        disabled={store.isStepReadOnly(stepIndex)}
                        size="small"
                        width="100%"
                        wrapperWidth="100%"
                        onChange={(e) => {
                          onSelectEventName(index, e.target.value)
                        }}
                        value={event.signature}
                        label={""}
                        labelBackground={"white"}
                      >
                        <option value={""} key={"chooseAnEvent"}>
                          Choose an event
                        </option>
                        {events.map((item) => (
                          <option value={item.signature} key={item.signature}>
                            {item.name}
                          </option>
                        ))}
                      </Select>
                      {event.signature && (
                        <ExpectedEventsDeclare
                          eventABI={events.find(
                            (x) => x.signature == event.signature,
                          )}
                          eventIndex={index}
                        />
                      )}
                      {!store.isStepReadOnly(stepIndex) ? (
                        <div css="margin-top: 10px;">
                          {index ==
                          store.steps[stepIndex]["expected_events"].length -
                            1 ? (
                            <>
                              <span
                                css={`
                                  color: #799fd4;
                                  cursor: pointer;
                                  text-decoration-line: underline;
                                `}
                                onClick={() => {
                                  addMoreExpectedEvent()
                                }}
                              >
                                Add expected events
                              </span>{" "}
                              &nbsp;&nbsp;
                            </>
                          ) : null}
                          <span
                            css={`
                              color: #799fd4;
                              cursor: pointer;
                              text-decoration-line: underline;
                            `}
                            onClick={() => {
                              removeExpectedEvent(index)
                            }}
                          >
                            Remove
                          </span>
                        </div>
                      ) : null}
                    </div>
                  ),
                )}
              </div>
            ) : null}
          </>
        ) : null}
      </div>
      {store.steps[stepIndex]["has_expected_events"] && (
        <div
          css={`
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding-left: 110px;
            padding-top: 10px;
            font-weight: 700;
          `}
        >
          <div>
            {store.steps[stepIndex]["pass_if_other_event_emitted"]
              ? "Pass if other events emitted"
              : "Fail if other events emitted"}
          </div>
          &nbsp;
          <div
            css={`
              color: #799fd4;
              cursor: pointer;
              text-decoration-line: underline;
              justify-self: right;
              font-size: 13px;
              font-weight: 100;
            `}
            onClick={() => {
              updatedPassIfOtherEventsEmitted()
            }}
          >
            Change
          </div>
        </div>
      )}
    </div>
  )
}
